// extracted by mini-css-extract-plugin
export default {"btn":"w45FZdEX0CF15Lr2_XyV","play":"VNKHkmYdn7RAJJvhq2hl","pause":"nDvEqAhx1ODIxfIpwhJw"};